/**
 * Reorder-media request validator — SCRUM-147 / DS-011-6.
 *
 * HTTP-boundary Zod schema for the reorder PUT payload
 * (`PUT /organizations/:slug/properties/:propertyId/media/reorder`).
 *
 * `orderedIds` is a non-empty array of UUIDs. The authoritative exact-multiset
 * validation (missing id / extra id / duplicate id against the property's
 * active rows) is performed INSIDE the repository transaction (codex I3 — no
 * TOCTOU). This schema only enforces the wire-shape: non-empty UUID[]. A
 * non-UUID / injection-shaped / non-array body yields a clean 400.
 *
 * Uses the same strict RFC-4122 UUID regex idiom as set-property-amenities
 * (lowercase hex, version 1–5, variant 8/9/a/b) — z.string().uuid() is lenient
 * on the version/variant nibbles.
 */
import { z } from 'zod';
/**
 * Strict RFC-4122 UUID regex (lowercase hex; version nibble pinned to 1–5;
 * variant nibble pinned to 8/9/a/b). Mirrors STRICT_UUID in
 * set-property-amenities.schema.ts.
 */
const STRICT_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
export const reorderMediaSchema = z.object({
    orderedIds: z.array(z.string().regex(STRICT_UUID)).min(1),
});
//# sourceMappingURL=reorder-media.schema.js.map